import React, { useEffect, useState } from "react";
import { Card, Stack, Button, Container, Typography, Grid, Box } from "@mui/material";
import Iconify from "../../components/iconify/Iconify";
import GoTable from "../../common/GoTable/GoTable";
import { MISSING_INVOICES_TABLE_HEADS } from "../../configs/TableHeaderConstants";
import EntityConstants from "../../configs/EntityConstants";
import { get, post } from "../../services/FetchHelper";
import SpinService from "../../services/SpinService";
import { missingInvoicesConfig } from "./Reports.utils";
import { Form, Formik } from "formik";
import GoForm from "../../components/Inputs/GoForm";
import { styled } from "@mui/material/styles";

const StyledRoot = styled("div")(({ theme }) => ({
    width: "100%",
    display: "block",
    padding: theme.spacing(2, 2, 2, 2),
    paddingBottom: '10px'
}));

const MissingInvoices = () => {
    const spinService = SpinService();
    const [formFields, setFormFields] = useState(missingInvoicesConfig.formFields);
    const [data, setData] = useState([]);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name ? { ...field, options } : field
            )
        );
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const response = await post(EntityConstants.MISSING_INVOICES, values);
        const result = await response.json();
        setData(result);
        spinService.off();
    };

    useEffect(() => {
        const fetchDeps = async () => {
            const [schoolsResp, termsResp] = await Promise.all([
                get(EntityConstants.SCHOOLSBYCOMPANIES),
                get(EntityConstants.TERMS, "max=all")
            ]);
            const [schools, terms] = await Promise.all([schoolsResp.json(), termsResp.json()]);
            attachOptions("school_id", schools);
            attachOptions("term_id", terms);
        };
        fetchDeps();
    }, []);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                    <Typography variant="h4" gutterBottom>
                        MISSING INVOICES
                    </Typography>
                </Stack>
                <Card>
                    <StyledRoot>
                        <Formik
                            enableReinitialize
                            initialValues={missingInvoicesConfig.state}
                            validationSchema={missingInvoicesConfig.schema}
                            onSubmit={(values) => handleSubmit(values)}
                        >
                            {({ values, touched, errors, handleChange, handleSubmit }) => (
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Grid container justifyContent="space-between" alignItems="center" rowSpacing={1} columnSpacing={1}>
                                        {formFields.map((formField, index) => (
                                            <Grid key={index} item xs={12} sm={12} md={4} lg={4}>
                                                <GoForm
                                                    config={formField}
                                                    values={values}
                                                    touched={touched}
                                                    errors={errors}
                                                    handleChange={handleChange}
                                                />
                                            </Grid>
                                        ))}
                                        <Grid item xs={12} sm={12} md={4} lg={4} style={{ display: "flex", justifyContent: "end" }}>
                                            <Box sx={{ p: 1 }}>
                                                <Button
                                                    variant="contained"
                                                    startIcon={<Iconify icon="eva:search-fill" />}
                                                    type="submit"
                                                >
                                                    Search
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Form>
                            )}
                        </Formik>
                    </StyledRoot>
                </Card>
                <Card>
                    <GoTable
                        tableHeads={MISSING_INVOICES_TABLE_HEADS}
                        tableDatas={data}
                        totalCount={0}
                        search={false}
                        pagination={false}
                    />
                </Card>
            </Container>
        </React.Fragment>
    );
};

export default MissingInvoices;
